<template>
<div>
  <!-- Список карточек -->
  <div class="diagnostics-list">
    <v-card
      v-for="(item, index) in items"
      :key="item.id != null ? item.id : index"
      class="mb-3 rounded-lg"
      outlined
      elevation="0"
      style="border-color: #e0e0e0;"
    >
      <v-card-text class="d-flex align-center justify-space-between py-4 px-4 flex-wrap">
        <div class="d-flex align-center flex-grow-1">
          <v-avatar color="#f3f4f6" size="36" class="mr-3">
            <v-icon color="#483CB9" small>mdi-account-outline</v-icon>
          </v-avatar>

          <div>
            <div class="d-flex align-center">
                <span class="text-subtitle-1 font-weight-bold grey--text text--darken-3">
                  {{ item.name }}
                </span>
              <v-chip
                v-if="item.isDraft"
                label
                small
                class="ml-3 font-weight-medium grey lighten-4 grey--text text--darken-2"
                style="height: 22px; font-size: 11px;"
              >
                Черновик
              </v-chip>
            </div>

            <div class="d-flex align-center mt-1 flex-wrap grey--text text--darken-1" style="font-size: 13px;">
              <v-icon x-small class="mr-1">mdi-domain</v-icon>
              <span class="mr-3">{{ item.company }}</span>

              <span class="mr-3">{{ item.position }}</span>

              <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
              <span>обн. {{ item.updated }}</span>
            </div>
          </div>
        </div>

        <div class="d-flex align-center mt-2 mt-sm-0">
          <v-btn
            outlined
            color="grey darken-2"
            small
            class="text-capitalize mr-2"
            style="border-color: #c0c0c0; height: 32px;"
            @click="$emit('open', item)"
          >
            Открыть
          </v-btn>
          <v-btn icon small color="error" @click="$emit('delete', item)">
            <v-icon small>mdi-trash-can-outline</v-icon>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>

  <!-- Пагинация -->
  <div class="d-flex align-center justify-end mt-4">
    <span class="text-caption grey--text mr-3">Показано {{ pagination.from }}–{{ pagination.to }} из {{ pagination.total }}</span>

    <v-select
      dense
      outlined
      hide-details
      :value="pagination.perPage"
      :items="[5, 10, 20]"
      style="max-width: 70px; "
      class="font-xs d-flex align-center"
      append-icon="mdi-chevron-down"
      @input="$emit('update:perPage', $event)"
    >
      <template v-slot:item="{item}">
        <div class="font-sm">{{item}}</div>
      </template>
      <template v-slot:append="">
          <v-icon size="20px">mdi-chevron-down</v-icon>
      </template>
      <template v-slot:selection="{item}">
        <div class="font-sm">
          {{item}}
        </div>
      </template>
    </v-select>

    <v-btn
      icon
      small
      color="grey lighten-1"
      :disabled="pagination.page <= 1"
      class="mr-1"
      style="width: 32px; height: 32px;"
      @click="$emit('prevPage')"
    >
      <v-icon small>mdi-chevron-left</v-icon>
    </v-btn>

    <v-btn
      small
      color="#483CB9"
      dark
      class="px-3"
      elevation="0"
      style="min-width: 32px; height: 32px;"
    >
      {{ pagination.page }}
    </v-btn>

    <v-btn
      icon
      small
      color="grey lighten-1"
      :disabled="pagination.page >= pagination.totalPages"
      class="ml-1"
      style="width: 32px; height: 32px;"
      @click="$emit('nextPage')"
    >
      <v-icon small>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</div>
</template>

<script>
export default {
  name: 'DiagnosticsList',
  props: {
    items: { type: Array, default: () => [] },
    pagination: {
      type: Object,
      default: () => ({
        from: 1,
        to: 1,
        total: 1,
        page: 1,
        perPage: 10,
        totalPages: 1
      })
    }
  }
};
</script>
